/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Font_SizeInputs */



/**
* | output |
* | --- |
* | "Captioner font size" |
*
* @param {Live_Caption_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_font_size = /** @type {((inputs?: Live_Caption_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("taille de la police du sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftgröße für Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione del carattere della didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("размер шрифта в редакторе подписей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño de fuente del subtitulador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕字体大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションのフォントサイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शनर फ़ॉन्ट आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("tamanho da fonte do legendador")
	return /** @type {LocalizedString} */ ("Captioner font size")
});